module.exports = __webpack_public_path__ + "static/media/hangman1.aa16b7f2.png";